import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  width: 100%;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  width: 100%;\n']);

import styled from 'styled-components';

export var Container = styled.div(_templateObject, function (_ref) {
  var justify = _ref.justify;
  return 'flex-' + justify;
});